// export const baseUrl =
//     process.env.NODE_ENV === 'production'
//         ? `${window.location.protocol}//${window.location.hostname}`
//         : `https://bussiness.joininto.com`;

export const baseUrlApi = "https://business.joininto.com";
export const baseUrlPhoto =
  process.env.NODE_ENV === "production"
    ? "https://api.joininto.com/"
    : "https://testapi.joininto.com";
export const sampleVenueId = "64071f9de2bd0b457ff60d3f";
export const playStoreLink =
  "https://play.google.com/store/apps/details?id=com.joininto";
